export enum ConceptDescriptionType {
  MANUAL = 'manual', // editable description for flat concepts
  STARMIND_ONTOLOGY = 'starmind_ontology', // un-editable description from the starmind ontology (wikidate)
  GENERATED = 'generated', // AI-generated (non-accepted) description only visible for the admin
  GENERATED_ACCEPTED = 'generated_accepted' // AI-generated description manually accepted by the admin
}

export enum ConceptSearchResultLanguageType {
  USER_LANGUAGE = 'user_language',
  OTHER_LANGUAGE = 'other_language'
}

export interface IStandardizedConceptLanguageBase {
  language: string;
  description?: string | null;
  description_type?: ConceptDescriptionType;
  primary_label?: string | null;
  label_match: string;
  is_verified_expert?: boolean
}

export interface IStandardizedConceptLanguageObject extends Omit<IStandardizedConceptLanguageBase, 'label_match'> {
  labels: string[];
  is_verified_expert?: boolean
}

export interface IConceptLabel {
  is_custom: boolean
  is_primary: boolean
  label: string
  language: string
}

export interface IConceptDescription {
  language: string;
  description: string;
  description_type?: ConceptDescriptionType;
}

export interface IConceptLanguageObjectWithFullLabels {
  language: string;
  labels: IConceptLabel[];
}

export interface IOverviewConcept extends IStandardizedConceptSingleLanguage {
  last_update: string;
  highlighted: boolean;
  score?: number
  qa_contributions?: boolean
}

export interface IOverviewVisibleConceptResponse {
  items: IOverviewConceptResponse[],
  total: number
}

export interface IOverviewConceptResponse extends IStandardizedConceptAllLanguages {
  highlighted: boolean;
  score?: number;
  qa_contributions?: boolean;
  last_update: string;
}

export interface IStandardizedConceptAllLanguages {
  concept_id: string;
  ontology_id?: string
  is_flat?: boolean
  labels_for_languages: IStandardizedConceptLanguageObject[];
  parents?: string[];
  is_excluded_from_suggestion?: boolean;
}

export interface IStandardizedConceptSingleLanguage extends IStandardizedConceptLanguageBase {
  concept_id: string;
}

export interface IConceptSearchResultItem extends IStandardizedConceptLanguageBase {
  concept_id?: string;
  ontology_id?: string;
  is_flat?: boolean;
}

export type IConceptImport = Omit<IStandardizedConceptAllLanguages, 'concept_id'>

export type ImportMatchType = 'new' | 'auto_update' | 'needs_review' | 'ambiguous' | 'skipped_global' | 'error'

export interface IConceptImportStatus {
  candidate: IConceptImport;
  should_import: boolean;
  concept_id?: string;
  matchType: ImportMatchType;
  existingConceptId?: string;
  existingDescription?: string;
  confirmed?: boolean;
}

export interface IComboboxSearchResultItem {
  text: string;
  value: IConceptSearchResultItem;
}

export interface IConceptExperienceStats {
  answers: number;
  recommendations: number;
  public_interactions: number;
  external_interactions: number;
}

export interface IConceptWithEncounters {
  complete_concept: IStandardizedConceptAllLanguages,
  encounter_count: number
}

export interface IGetConceptsResponse {
  items: IConceptWithEncounters[],
  total: number
}

export enum ConceptRelations {
  IS_PARENT_OF = 'is_parent_of'
}
